/* RESPONSIBLE TEAM: team-ai-agent */
import ContentEditorController from 'embercom/controllers/apps/app/content/edit';

export default ContentEditorController;
